import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getAuth, applyActionCode } from "firebase/auth"
import { useLocation } from "react-router-dom"
import { Card, CardContent, Typography, CircularProgress, Container, Stack, Box } from "@mui/material"
import ResetPassword from "./reset-password"
import icon from "@/images/pngs/icon.png"

const EmailVerification = () => {
  const [message, setMessage] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const location = useLocation()
  const [mode, setMode] = useState<"verifyEmail" | "resetPassword" | null>()

  useEffect(() => {
    const verifyEmail = async () => {
      const auth = getAuth()
      const urlParams = new URLSearchParams(location.search)
      const oobCode = urlParams.get("oobCode")

      setMode(urlParams.get("mode") as "verifyEmail" | "resetPassword" | null)

      if (oobCode) {
        try {
          await applyActionCode(auth, oobCode)
          setMessage("Email verified successfully!")
          window.location.href = "/"
        } catch (error) {
          setMessage("Error verifying email. Please try again.")
          console.error(error)
        }
      } else {
        setMessage("Invalid verification link.")
      }

      setIsLoading(false)
    }
    verifyEmail()
  }, [location, navigate])

  return (
    <>
      {mode === "resetPassword" && <ResetPassword />}
      {mode === "verifyEmail" && (
        <Container maxWidth="sm">
          <Stack alignItems="center" justifyContent="center" height="100%" spacing={3}>
            <Card variant="outlined" sx={{ p: 4, display: "flex", alignItems: "center", flexDirection: "column" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Box display="flex" justifyContent="center" mb={2}>
                  <img src={icon} alt="Brotherhood" style={{ width: 72, height: 72 }} />
                </Box>
                <Typography variant="h4">Email Verification</Typography>
                {isLoading ? (
                  <CircularProgress sx={{ mt: 2 }} />
                ) : (
                  <Typography variant="body1" sx={{ color: "text.secondary", mt: 2 }}>
                    {message}
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Stack>
        </Container>
      )}
    </>
  )
}

export default EmailVerification
